export const homeObjOne =  {
    id: 'about', 
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Perfect Plants',
    headLine: 'Your Plant Goals delivered to your door',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vestibulum mattis ullamcorper velit sed. Nulla aliquet enim tortor at. Penatibus et magnis dis parturient. ',
    buttonLabel: 'Get Started',
    imgStart: false,
    img: "/images/svg-1.svg", 
    alt: 'Plant',
    dark:true,
    primary:true,
    darkText: false

};
export const homeObjTwo =  {
    id: 'discover', 
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Rare Tropical Plants',
    headLine: 'Unique and Hard to Find Plants',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vestibulum mattis ullamcorper velit sed. Nulla aliquet enim tortor at. Penatibus et magnis dis parturient. ',
    buttonLabel: 'Learn More',
    imgStart: true,
    img: "/images/svg-2.svg", 
    alt: 'Plant',
    dark:false,
    primary:false,
    darkText: true

};
export const homeObjThree =  {
    id: 'signup', 
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Personalized Selections',
    headLine: 'Join us for exclusive access to plant care and tips',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vestibulum mattis ullamcorper velit sed. Nulla aliquet enim tortor at. Penatibus et magnis dis parturient. ',
    buttonLabel: 'Start Now',
    imgStart: true,
    img: "/images/svg-3.svg", 
    alt: 'Plant',
    dark:false,
    primary:false,
    darkText: true

};